<script setup lang="ts">
/** Appendix A — Particulars of Beneficial Owner (self-declaration). */
import BoParticularsTable from './parts/BoParticularsTable.vue';
import BoCriteriaBlock from './parts/BoCriteriaBlock.vue';
import BoAppendixSigners from './parts/BoAppendixSigners.vue';
</script>

<template>
  <div class="allot-doc">
    <p class="doc-sec-title">Appendix A</p>
    <p class="doc-p" style="text-align:center; margin-top:-4px">(Particulars of beneficial owner)</p>

    <p class="doc-lbl-title">1. The beneficial ownership information:</p>
    <BoParticularsTable />
    <BoCriteriaBlock doc-code="BA01" />

    <p class="doc-p" style="padding-top:14px">I hereby declare as follows:</p>
    <p class="doc-p" style="font-style:italic; padding-left:8px">
      “I hereby confirmed that the facts and information stated in this letter are true and to the best of my knowledge and belief.”
    </p>
    <BoAppendixSigners var-key="BA01" />
    <p class="doc-p" style="padding-top:4px">[BENEFICIAL OWNER]</p>
  </div>
</template>

<style src="./boAppendixDoc.css"></style>
